module.exports = __webpack_public_path__ + "static/media/www.moominworld.fi.7f680b22.png";